<template>
    <b-modal v-model="show" size="xl" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row" v-if="rentData && rentData.analogs && rentData.analogs.length > 2">
                <div class="col-12">
                    <div class="card card-form">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="table-responsive">
                                        <div class="table-wrapper">
                                          <table class="table table-sm table-striped comparison-table" style="min-width: 900px">
                                              <tr>
                                                  <th rowspan="2" colspan="2" class="text-center">Таққослаш элементлари</th>
                                                  <th rowspan="2" class="text-center">Баҳолаш объекти</th>
                                                  <th :colspan="rentData.analogs.length" class="text-center">
                                                      Таққослаш объекти(аналоглар)
                                                  </th>
                                              </tr>
                                              <tr>
                                                  <th class="text-center" v-for="(analog,index) in rentData.analogs" :key="index" style="position: relative">
                                                      аналог {{index + 1}}
                                                  </th>
                                              </tr>
                                              <tr>
                                                  <td class="text-center" rowspan="2">Фойдаланилган маълумотлар манбаи</td>
                                                  <td>Манба</td>
                                                  <td></td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                      {{analog.source}}
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td>Маълумотлар баъзасида сақланаётган хавола (ссылка)</td>
                                                  <td></td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                      эълон рақами: {{analog.id}}
                                                      <br />
                                                      <a :href="`https://e-rieltor.uz/products/product/${analog.id}`" target="_blank">https://e-rieltor.uz/products/product/{{analog.id}}</a>
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td class="text-center">Объект номи</td>
                                                  <td></td>
                                                  <td class="text-right"></td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-right">
                                                      Бино ва иншоатлар
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td class="text-center">Ижарага бериш майдони кв.м</td>
                                                  <td></td>
                                                  <td class="text-right">{{rentData.rentArea}}</td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-right">
                                                      {{analog.rentArea}}
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td class="text-center">1 ойлик ижара тулови (сўм)</td>
                                                  <td></td>
                                                  <td class="text-right"></td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-right">
                                                      {{analog.rentPerMonth | currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td class="text-center">1 ойлик ижара тулови буйича таклифи (АКШ $) да 1м2 га</td>
                                                  <td></td>
                                                  <td class="text-right"></td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-right">
                                                      {{analog.rentPerUnitUSD | currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td class="text-center">1 ойлик ижара тулови буйича таклифи сум 1м2 да</td>
                                                  <td></td>
                                                  <td class="text-right"></td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-right">
                                                      {{analog.rentPerUnit | currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td class="text-center">Таклиф буйича 1 кв.мга 1 йиллик тулов</td>
                                                  <td></td>
                                                  <td class="text-right"></td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-right">
                                                      {{analog.rentPerUnitYearly | currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </td>
                                              </tr>
                                              <tr class="section-start">
                                                  <td :colspan="rentData.analogs.length + 3" class="text-center">
                                                      Киритилган тузатишлар ва уларнинг мохияти
                                                  </td>
                                              </tr>
                                              <template v-if="realEstate.fixByIndex">
                                                  <tr>
                                                      <td class="text-center" rowspan="4">Эълон санаси</td>
                                                      <td>
                                                          Савдога кўйилган ёки сотилиш санаси
                                                      </td>
                                                      <td class="text-center">{{rentData.saleDate}}</td>
                                                      <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                          {{analog.saleDate}}
                                                      </td>
                                                  </tr>
                                                  <tr>
                                                      <td>Кимматлашув коффиценти</td>
                                                      <td class="text-center">{{rentData.coefficient.index}}</td>
                                                      <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                          {{analog.coefficient.index}}
                                                      </td>
                                                  </tr>
                                              </template>
                                              <template v-else>
                                                  <tr>
                                                      <td class="text-center" rowspan="4">Эълон санаси</td>
                                                      <td>
                                                          Савдога кўйилган ёки сотилиш санаси
                                                      </td>
                                                      <td class="text-center">{{rentData.saleDate}}</td>
                                                      <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                          {{analog.saleDate}}
                                                      </td>
                                                  </tr>
                                                  <tr>
                                                      <td>Валюта курси</td>
                                                      <td class="text-center">{{rentData.exchangeRate | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                                      <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                          {{analog.exchangeRate | currency('', 2, { thousandsSeparator: ' ' })}}
                                                      </td>
                                                  </tr>
                                              </template>
                                              <tr>
                                                  <td>Тузатиш</td>
                                                  <td></td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                      {{analog.fix.source | currency('', 4, { thousandsSeparator: ' ' })}}
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td>1 м.кв учун тузатишдан кейинги киймат</td>
                                                  <td></td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-right">
                                                      {{analog.calculated.sourceFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td class="text-center" rowspan="3">Ижарадан кейинги харажатлар учун</td>
                                                  <td></td>
                                                  <td class="text-center">{{rentData.afterSale}}</td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                      {{analog.afterSale}}
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td>Тузатиш</td>
                                                  <td></td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                      {{analog.fix.afterSales | currency('', 4, { thousandsSeparator: ' ' })}}
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td>1 м.кв учун тузатишдан кейинги киймат</td>
                                                  <td></td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-right">
                                                      {{analog.calculated.afterSales | currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td class="text-center" rowspan="4">Қулайликлари</td>
                                                  <td>
                                                      Мухандислик камуникациялари
                                                  </td>
                                                  <td class="text-center">{{rentData.physicalCharacteristics}}</td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                      {{analog.physicalCharacteristics}}
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td></td>
                                                  <td class="text-center">{{rentData.coefficient.physicalCharacteristics}}</td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                      {{analog.coefficient.physicalCharacteristics}}
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td>Тузатиш</td>
                                                  <td></td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                      {{analog.fix.physicalCharacteristics}}
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td>1 м.кв учун тузатишдан кейинги киймат</td>
                                                  <td></td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-right">
                                                      {{analog.calculated.physicalCharacteristics | currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td class="text-center" rowspan="4">Архитектуравий услуб</td>
                                                  <td>
                                                      Архитектуравий услуб
                                                  </td>
                                                  <td class="text-center">{{rentData.architecturalStyle}}</td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                      {{analog.architecturalStyle}}
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td></td>
                                                  <td class="text-center">{{rentData.coefficient.architecturalStyle}}%</td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                      {{analog.coefficient.architecturalStyle}}%
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td>Тузатиш</td>
                                                  <td></td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                      {{analog.fix.architecturalStyle}}%
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td>1 м.кв учун тузатишдан кейинги киймат</td>
                                                  <td></td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-right">
                                                      {{analog.calculated.architecturalStyleFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </td>
                                              </tr>
                                              <!--<tr>-->
                                                  <!--<td class="text-center" rowspan="4">Жалб килувчанлиги</td>-->
                                                  <!--<td>-->
                                                      <!--Жойлашуви-->
                                                  <!--</td>-->
                                                  <!--<td class="text-center">{{rentData.specialComfort}}</td>-->
                                                  <!--<td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">-->
                                                      <!--{{analog.specialComfort}}-->
                                                  <!--</td>-->
                                              <!--</tr>-->
                                              <!--<tr>-->
                                                  <!--<td></td>-->
                                                  <!--<td class="text-center">{{rentData.coefficient.specialComfort}} %</td>-->
                                                  <!--<td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">-->
                                                      <!--{{analog.coefficient.specialComfort}} %-->
                                                  <!--</td>-->
                                              <!--</tr>-->
                                              <!--<tr>-->
                                                  <!--<td>Тузатиш</td>-->
                                                  <!--<td></td>-->
                                                  <!--<td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">-->
                                                      <!--{{analog.fix.specialComfort}} %-->
                                                  <!--</td>-->
                                              <!--</tr>-->
                                              <!--<tr>-->
                                                  <!--<td>1 м.кв учун тузатишдан кейинги киймат</td>-->
                                                  <!--<td></td>-->
                                                  <!--<td v-for="(analog,index) in rentData.analogs" :key="index" class="text-right">-->
                                                      <!--{{analog.calculated.specialComfortFixed | currency('', 2, { thousandsSeparator: ' ' })}}-->
                                                  <!--</td>-->
                                              <!--</tr>-->
                                              <tr>
                                                  <td class="text-center" :rowspan="isRegionFixCalculated ? 6 : 3">Объектнинг Жойлашган ери</td>
                                                  <td>Объект жойлашган туман</td>
                                                  <td class="text-center">{{rentData.region}}</td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                      {{analog.region}}
                                                  </td>
                                              </tr>
                                              <template v-if="isRegionFixCalculated">
                                                  <tr>
                                                      <td>Худуд даромади (Млярд сўм)</td>
                                                      <td class="text-center">{{rentData.provinceIncome}}</td>
                                                      <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                          {{analog.provinceIncome}}
                                                      </td>
                                                  </tr>
                                                  <tr>
                                                      <td>Ахоли сони (мингда)</td>
                                                      <td class="text-center">{{rentData.populace}}</td>
                                                      <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                          {{analog.populace}}
                                                      </td>
                                                  </tr>
                                                  <tr>
                                                      <td>Вилоят ёки шахар ахоли жон бошига йиллик даромадининг худуд улуши фоизда</td>
                                                      <td class="text-center">{{rentData.coefficient.regionCoefficient | currency('', 2, { thousandsSeparator: ' ' })}} %</td>
                                                      <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                          {{analog.coefficient.regionCoefficient | currency('', 2, { thousandsSeparator: ' ' })}} %
                                                      </td>
                                                  </tr>
                                              </template>
                                              <tr>
                                                  <td>Тузатиш</td>
                                                  <td></td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                      {{analog.fix.region | currency('', 2, { thousandsSeparator: ' ' })}} %
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td>1 м.кв учун тузатишдан кейинги киймат</td>
                                                  <td></td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-right">
                                                      {{analog.calculated.regionFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td class="text-center" rowspan="4">Функцианал жихатдан фойдалилиги</td>
                                                  <td>
                                                      Объект номи
                                                  </td>
                                                  <td class="text-center">{{rentData.category}}</td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                      {{analog.category}}
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td></td>
                                                  <td class="text-center">{{rentData.coefficient.categoryCoefficient}}%</td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                      {{analog.coefficient.categoryCoefficient}}%
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td>Тузатиш</td>
                                                  <td></td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-center">
                                                      {{analog.fix.category}} %
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td>1 м.кв учун тузатишдан кейинги киймат</td>
                                                  <td></td>
                                                  <td v-for="(analog,index) in rentData.analogs" :key="index" class="text-right">
                                                      {{analog.calculated.categoryFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </td>
                                              </tr>
                                              <tr class="section-start">
                                                  <td>Жами тузатишлар</td>
                                                  <td></td>
                                                  <td class="text-center">Сони</td>
                                                  <td v-for="(analog, index) in rentData.analogs" :key="index" class="text-center">
                                                      {{analog.fixedItemsCount}}
                                                  </td>
                                              </tr>
                                              <tr class="section-start">
                                                  <td>Танланган салмок</td>
                                                  <td></td>
                                                  <td class="text-center">Фоиз</td>
                                                  <td v-for="(analog, index) in rentData.analogs" :key="index" class="text-center">
                                                      {{analog.fixedItemsSharePercent | currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </td>
                                              </tr>
                                              <tr class="section-start">
                                                  <td>Салмоклар микдори</td>
                                                  <td></td>
                                                  <td class="text-center">Сум</td>
                                                  <td v-for="(analog, index) in rentData.analogs" :key="index" class="text-center">
                                                      {{analog.fixedItemsShareAmount | currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </td>
                                              </tr>
                                              <tr class="section-start bold-row">
                                                  <td :colspan="2">Тузатилган 1 кв.мга 1 йиллик тулов микдори</td>
                                                  <td class="text-center" :colspan="4">
                                                      {{rentData.total | currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </td>
                                              </tr>
                                          </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn float-right mr-2" @click="show=!show">
                OK
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal';
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal';
    export default {
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                rentData: {},
                realEstate: {}
            }
        },
        computed: {
            isRegionFixCalculated() {
                return this.rentData && !this.rentData.regionFixCalculated
            }
        },
        created() {
            this.$eventBus.$on("showIncomeComparisonRentModal", (data) => {
                this.realEstate = data;
                this.rentData = data.comparisonNewIncome.incomeRent;
                this.show = true;
            })
        }
    }
</script>

<style scoped>
    .comparison-table {
        font-size: 14px;
    }
    .comparison-table th {
        /*vertical-align: top;*/
        border: 1px solid #dee2e6;
        border-collapse: collapse;
        background-color: #E9FAFD;
    }
    .comparison-table td {
        border: 1px solid #dee2e6;
        border-collapse: collapse;
    }
    .comparison-table .percentage {
        margin: auto;
        width: 110px !important;
        display: inline-block;
    }
    .comparison-table .percentage div {
        width: 80px !important;
        float: left;
    }
    .comparison-table .percentage span {
        display: block;
        margin: 7px 5px;
        float: left;
    }
    .comparison-table .section-start td {
        background-color: #F3F3F3;
    }
    .comparison-table .section-start > td:first-child {
        font-weight: bold;
    }
</style>